<template>
    <div>
        <div v-if="actionPlanLearnHabit.length">
            <div v-for="(value,index) in actionPlanLearnHabit" :key="index">
                <div class="content contentPlanStudyDevelop" v-for="(val,idx) in value.targetHabit" :key="'xg'+idx">
                    <MiddleTitle title='学习习惯养成' v-if="index==0&&idx==0"></MiddleTitle>
                    <div  style="padding-top: 20px;margin-bottom: 28px;" v-if="idx==0">
                        <SmallTitle :title="value.name"></SmallTitle>
                    </div>
                    <div class="hobbit">
                        <p class="title">
                            第{{idx+1}}次行动计划
                        </p>
                        <p  v-for="(va,i) in val" :key="i">
                            <span>养成习惯：</span>
                            {{va.targetHabit}}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="content contentPlanStudyDevelop">
            <MiddleTitle title='学习习惯养成'></MiddleTitle>
            <div class="noContent">暂无内容~~！</div>
        </div>
    </div>
</template>
<script>
    import MiddleTitle from './middleTitle'
    import SmallTitle from './smallTitle'
    export default {
        name: "pagePlanStudyDevelop",
        props: ['actionPlanLearnHabit'],
        components: {
            MiddleTitle,SmallTitle
        },
        data() {
            return {
            }
        },
        computed: {

        },
        methods: {

        },
    }
</script>
<style scoped lang="less">
.pagePlanStudyDevelop {

}
</style>